import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { add_par_loading: false, add_par: '', add_par_error: false };

export function addParticipents(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_ADD_PARTICIPENTS:
            return {
                ...state,
                add_par_loading: true,
                add_par: '',
                add_par_error: false
            };
        case organisationConstants.RESPONSE_ADD_PARTICIPENTS:
            return {
                ...state,
                add_par_loading: false,
                add_par: action.add_par,
                add_par_error: false
            };
        case organisationConstants.ERROR_ADD_PARTICIPENTS:
            return { 
                ...state,
                add_par_loading: false,
                add_par: '',
                add_par_error: true
            };
        case organisationConstants.CLEAR_ADD_PARTICIPENTS:
            return initialState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/addParticipents.reducer.js